import { Component, Input, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-header-total-card',
  templateUrl: './header-total-card.component.html',
  styleUrls: ['./header-total-card.component.css']
})
export class HeaderTotalCardComponent implements OnInit {
  // @Input() title: string;
  @Input() value: number;
  @Input() invest: number;
  @Input() titleOverride: string;
  @Input() investTitle: string;
  @Input() investDesc: string;

  title: string = "Remaining Unfunded Costs";
  //shortDesc: string = "Needed to cover unfunded costs";

  constructor() {
    
   }

  ngOnInit() {
    if(this.titleOverride){
      this.title = this.titleOverride;
    }

    if(!this.investTitle){
      this.investTitle = "START INVESTING TODAY"
    }

    if(!this.investDesc){
      this.investDesc = "Needed to cover unfunded costs"
    }
  }

}
